import styled, {createGlobalStyle} from 'styled-components';
import {
  ButtonBase,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const GoogleMapContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 1;

  /* Replace default Google Maps styles */
  &.gMap {
    /* You can add specific styles here if needed */
  }

  & .gm-style .gm-style-iw-c {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
  }

  & .gm-style .gm-style-iw-d {
    overflow: hidden !important;
  }

  & .gm-style .gm-style-iw-d div.gmap__infoHotel {
    position: relative;
    width: 12rem;
    max-width: 30rem;
    background-color: #141823;
    padding: 0.5rem 1.1875rem 0.5rem 1.125rem;
    border-radius: 0.8rem;
    text-align: center;
    color: #ffffff;
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1.2rem;
  }

  & .gm-style .gm-style-iw-d div.gmap__infoHotel::after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: #141823 transparent transparent transparent;
    border-top-color: #141823;
    border-width: 8px;
    margin-left: -8px;
    border-radius: 3%;
  }

  & .gm-style .gm-style-iw-d div.gmap__infoPOI {
    position: relative;
    font-size: 1.2rem;
    font-weight: 600;
    width: 12rem;
    max-width: 30rem;
    border-radius: 0.8rem;
    background-color: #141823;
    color: white;
    text-align: center;
    margin-bottom: 1.2rem;
    padding: 0.5rem 1.1875rem 0.5rem 1.125rem;
  }

  & .gm-style .gm-style-iw-d div.gmap__infoPOI::after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: #141823 transparent transparent transparent;
    border-top-color: #141823;
    border-width: 8px;
    margin-left: -8px;
    border-radius: 3%;
  }

  & .gm-style .gm-style-iw-t::after {
    background: none;
  }

  /* Additional custom styles can be added here */
`;

export const MapGlobalStyles = createGlobalStyle`
  /* GOOGLE MAPS STYLES FOR DETAILS */
  .pac-container {
    transform: translate(-2.2rem, 1.4rem);
    width: 100%;
  }

  /* don't show 'close' button since info window opens on mouseover */
  .gm-style-iw button {
    display: none!important;
  }
`;

export const ExpansionWrapper = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 132px;
    right: 148px;
    cursor: pointer;
    z-index: 1;
    `,
);
export const ToolTipTextDiv = styled.span(
  props => `
  width: 21rem;
	position: relative;
  background-color: #141823;
  border-radius: 1.5rem;
  padding: 15px 18px;
  text-align:center;
  color:white;
  &::after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color:  #141823 transparent transparent transparent;
    border-top-color: #141823 ;
    border-width: 8px;
    margin-left: -8px;
  }
  
`,
);

// ZoomInOutSpan

export const ZoomInOutWrapper = styled.div(
  props => `
    position: absolute;
    right: 20px !important;
    bottom: 20px !important;
      `,
);
export const ZoomInOutInnerWrapper = styled.div(
  props => `
    user-select: none;
    box-shadow: 0 .8rem .6rem -.6rem ${props.theme.colors.shadow.light};
    border-radius: 12px;
    cursor: pointer;
    background-color: rgb(255, 255, 255);
    width:6rem;
    height: 100px;
      `,
);
export const ZoomInOutSpan = styled(ButtonBase)(
  props => `
    background: none;
    display: block;
    border: 0px;
    margin: 0px;
    padding: 0px;
    text-transform: none;
    appearance: none;
    position: relative;
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    width: 6rem;
    height: 50px;
    top: 0px;
    left: 0px;
      `,
);
export const ZoomInImg = styled.img(
  props => `
      width: 22px;
      // height:20px;
    `,
);

export const DividerSpan = styled.span(
  props => `
    display:block;
    position: relative;
    overflow: hidden;
    width: 40px;
    height: 1px;
    margin: 0px 10px;
    background-color: rgb(230, 230, 230);
    top: 0px;
      `,
);

export const ExpandOuterWrapper = styled(PrimaryLink)(
  props => `
    position: absolute;
    right: 20px !important; 
    top: 20px !important;
    user-select: none;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.11);
    border-radius: 12px;
    cursor: pointer;
    background-color: rgb(255, 255, 255);
    width: 6rem;
    height: 6rem;
    display:flex;
    align-items: center;
    justify-content: center;
      `,
);

//SearchBar & AutoSuggestWraper
